import React from 'react';
import { Link as GatsbyLink } from 'gatsby';

const Link = ({
    _type,
    title,
    url,
    product,
    slug,
    openInNewWindow,
    pageName,
    journalName,
    productName,
    collectionName,
    children,
    ...props
}) => {
    if (_type === 'collectionLink') {
        return (
            <GatsbyLink
                {...props}
                title={title || collectionName}
                target={openInNewWindow ? '_blank' : null}
                to={`/collections/${slug || url}`}
            >
                {children || title || collectionName}
            </GatsbyLink>
        );
    } else if (_type === 'productLink') {
        return (
            <GatsbyLink
                {...props}
                title={title || productName}
                target={openInNewWindow ? '_blank' : null}
                to={`/products/${slug || url}`}
            >
                {children || title || productName}
            </GatsbyLink>
        );
    } else if (_type === 'journalLink') {
        return (
            <GatsbyLink
                {...props}
                title={title || journalName}
                target={openInNewWindow ? '_blank' : null}
                to={`/journal/${slug || url}`}
            >
                {children || title || journalName}
            </GatsbyLink>
        );
    } else if (_type === 'pageLink') {
        return (
            <GatsbyLink
                {...props}
                title={title || pageName}
                target={openInNewWindow ? '_blank' : null}
                to={`/${slug || url}`}
            >
                {children || title || pageName}
            </GatsbyLink>
        );
    } else if (url[0] === '/') {
        return (
            <GatsbyLink
                {...props}
                title={title}
                target={openInNewWindow ? '_blank' : null}
                rel={openInNewWindow ? 'noopener noreferrer' : null}
                to={url}
            >
                {children || title}
            </GatsbyLink>
        );
    } else {
        return (
            <a
                {...props}
                title={title}
                target={openInNewWindow ? '_blank' : null}
                rel={openInNewWindow ? 'noopener noreferrer' : null}
                href={url}
            >
                {children || title}
            </a>
        );
    }
};

export default Link;